<app-supplier-round-list-ssy1230detail [state]="viewState.Details"></app-supplier-round-list-ssy1230detail>